import React from 'react'
import { View } from 'react-native'
import { connect } from 'react-redux'
import { useLocation, useNavigate } from 'react-router'

import { cloneDeep } from 'lodash-es'
import PropTypes from 'prop-types'

import LtIcon from '@lyrahealth-inc/ui-core/lib/lyraTherapy/assignmentsList/LtIcon'
import { ChevronIcon, ChevronIconDirection } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ChevronIcon'

import styles from './assignmentLibrary.module.scss'
import { programs as programMap } from '../../common/constants/appConstants'
import { CLIENT_ACTIVITIES, CLIENTS_NEW_TRACK } from '../../common/constants/routingConstants'
import { getLyraTherapyContentsPrograms } from '../../data/lyraTherapy/contentSelectors'
import { RootState } from '../../data/store'
import MiniBackNav from '../miniBackNav/MiniBackNav'

export const TrackLibrary = ({ programs }: any) => {
  const navigate = useNavigate()
  const location = useLocation()

  const sessionCount = location?.state?.sessionCount
  const handleBackClicked = () => {
    const targetRoute = CLIENT_ACTIVITIES.route
    navigate(targetRoute, { state: { sessionCount } })
  }

  const tracks = cloneDeep(
    programs.find((program: any) => program.name === programMap.SingleSessionCoaching)?.curricula.tracks,
  )
  delete tracks.default_SingleSessionCoaching

  const handleTrackClicked = (track: any) => {
    navigate(CLIENTS_NEW_TRACK.route, { state: { track, sessionCount } })
  }

  return (
    <View>
      <div className={styles.container}>
        <MiniBackNav backFunc={handleBackClicked} subText='Client Activities' />
        <div style={{ width: '100%' }}>
          <h2 className={styles['main-header']}>Share care plan</h2>
          <div className={styles['list-container']}>
            {Object.entries(tracks).map(([trackId, track]) => (
              // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
              <div key={trackId} className={styles['list-item-container']} onClick={() => handleTrackClicked(track)}>
                <div className={styles.name}>
                  <div className={styles.icon}>
                    <LtIcon type={'track'} />
                  </div>
                  {(track as any).title}
                </div>
                <div className={styles['session-info']}>
                  <div className={styles['session-count']}>
                    {(track as any).curriculumSchedule.length} week{(track as any).curriculumSchedule.length > 1 && 's'}
                  </div>
                </div>
                <div>
                  <ChevronIcon direction={ChevronIconDirection.RIGHT} size={13} fillColor={styles.x_soft_black} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </View>
  )
}

TrackLibrary.propTypes = {
  programs: PropTypes.array,
}

const mapStateToProps = (state: RootState) => {
  return {
    programs: getLyraTherapyContentsPrograms(state),
  }
}

export default connect(mapStateToProps, null)(TrackLibrary)
